<template>
  <div>
    <div>
      <p class="title">
        尊敬的用户
      </p>
      <p class="title">
        您已完成实名认证!
      </p>
      <van-button type="primary" size="large" to="/">
        前往首页
      </van-button>
    </div>
  </div>
</template>
<script type="text/javascript">
import { UpdateAuthLogByToken } from '@/api/qrCode'
export default {
  components: {},
  data() {
    return {}
  },
  mounted() {
    this.UpdateAuthLogStatus()
  },
  methods: {
    UpdateAuthLogStatus() {
      const sceneId = this.$route.query.sceneId // 场景值id
      const webUserId = this.$store.getters.webUserInfo.id // 用户id
      if (sceneId != null && sceneId !== '') { // 如果不是从web端扫码过来的则不需要
        UpdateAuthLogByToken({
          token: sceneId,
          status: 'AuthOrized', // 认证成功
          webUserId: webUserId // 用户id
        }).then(() => {})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
</style>
